// Reducer :
export const initialState = {
  toggle: true,
  user: null,
  error: null,
  myfamily: null,
  myrelative: null,
  search: null,
  error: null,
  notify: null,
  linkedFamily: null,
  metadata: null,
  mapRelativeDesc: null,
};

const reducer = (state, action) => {
  // console.log(state, action)
  switch (action.type) {
    // Error Message:
    case "ERROR":
      return {
        ...state,
        error: action.message,
      };

    case "RESET_ERROR":
      return initialState;

    // Dark Mode:
    case "TOGGLE_HEADER":
      return {
        ...state,
        toggle: action.toggle,
      };

    // Metadata:
    case "SET_METADATA":
      return {
        ...state,
        metadata: action.metadata,
      };

    // Handle User :
    case "SET_USER":
      return {
        ...state,
        user: action.user,
      };

    // My Family Handler:
    case "MY_FAMILY":
      return {
        ...state,
        myfamily: action.myfamily,
      };

    case "LINKED_FAMILY":
      return {
        ...state,
        linkedFamily: action.linkedFamily,
      };

    // My Family Handler:
    case "MY_RELATIVE":
      return {
        ...state,
        myrelative: action.myrelative,
      };

    // Handle Search:
    case "HANDLE_SEARCH":
      return {
        ...state,
        search: action.search,
      };

    //  Notify Error:
    case "NOTIFY_ERROR":
      return {
        ...state,
        error: action.error,
      };

    //  Notify Error:
    case "SET_NOTIFICATION":
      return {
        ...state,
        notify: action.notify,
      };

    // Relative Maps:
    case "MAP_OF_RELATIVE_DESC":
      return {
        ...state,
        mapRelativeDesc: action.mapRelativeDesc,
      };

    // Default:
    default:
      return state;
  }
};

export default reducer;
